import { createContext, useContext } from 'react';
import { TBodyTextProps } from '@/common/components/BodyText/BodyText';
import { TLabelProps } from '@/common/components/Label/Label';

export const TextContext = createContext<
  Omit<TBodyTextProps | TLabelProps, 'children' | 'context'>
>({});

export const TextProvider = TextContext.Provider;

export type TTextProviderType = 'label' | 'body';

export const useTextProvider = () => {
  return useContext(TextContext);
};
